import type { BookingSource, BookingStatus, StayPhase } from '@/shared/api';
import type { PillVariant } from '../types';

export type { PillVariant };

/**
 * Sprint-8 B.1.2: zentralisiert Label + Pill-Variant + Range-Format fuer die BookingsList.
 * Wird ausserhalb der React-Komponente getestet (Vitest).
 */

export const statusLabels: Record<BookingStatus, string> = {
  Pending: 'Anfrage',
  Confirmed: 'Bestätigt',
  CheckedIn: 'Eingecheckt',
  CheckedOut: 'Ausgecheckt',
  Cancelled: 'Storniert',
  NoShow: 'No-Show',
};

export const statusVariants: Record<BookingStatus, PillVariant> = {
  Pending: 'outline',
  Confirmed: 'accent',
  CheckedIn: 'accent',
  CheckedOut: 'default',
  Cancelled: 'error',
  NoShow: 'warning',
};

export const stayPhaseLabels: Record<StayPhase, string> = {
  DataQuality: 'Daten prüfen',
  Pending: 'Ausstehend',
  Upcoming: 'Bevorstehend',
  Arrival: 'Anreise',
  InHouse: 'Im Haus',
  Departure: 'Abreise',
  Completed: 'Abgeschlossen',
  Cancelled: 'Storniert',
  NoShow: 'No-Show',
};

export const stayPhaseVariants: Record<StayPhase, PillVariant> = {
  DataQuality: 'error',
  Pending: 'outline',
  Upcoming: 'default',
  Arrival: 'accent',
  InHouse: 'on',
  Departure: 'warning',
  Completed: 'default',
  Cancelled: 'error',
  NoShow: 'warning',
};

export function bookingStatusLabel(status: BookingStatus, source: BookingSource): string {
  return status === 'Pending' && source === 'Manuell' ? 'Zahlung offen' : statusLabels[status];
}

/**
 * Kurzes DE-Datum (zweistellig Tag.Monat.Jahr-zweistellig). Bewusst kompakt fuer die
 * Range-Cell — die Tabelle hat 7 Spalten und Datum darf nicht zu breit werden.
 */
function formatShortDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${String(d.getFullYear()).slice(2)}`;
}

/**
 * Range-Cell: "01.07.26 → 05.07.26". Bei identischen Daten (theoretisch unmoeglich,
 * Defense) wird einmal angezeigt.
 */
export function formatBookingRange(checkInIso: string, checkOutIso: string): string {
  const a = formatShortDate(checkInIso);
  const b = formatShortDate(checkOutIso);
  if (a === b) return a;
  return `${a} → ${b}`;
}
